import { useMutation, useQueryClient, useQuery } from 'react-query';
import { getAdminProfile, updateAdminProfile, updateBannerImage, updateProfileImage } from '../../api/admin/adminProfile';
import useAdminProfileStore from '../../store/admin/adminProfileStore';


export const useAdminProfile = () => {
    const queryClient = useQueryClient();
    const { setProfile, updateProfile, setError, setLoading } = useAdminProfileStore();
  
    const { data: profile, isLoading: isFetchingProfile } = useQuery(
      'adminProfile',
      getAdminProfile,
      {
        onSuccess: (data) => {
          setProfile(data);
        },
        onError: (error) => {
          if (error.response?.status === 404) {
            // Profile doesn't exist yet - this is an expected state
            setProfile(null);
          } else {
            setError(error?.response?.data?.message || 'Failed to fetch profile');
          }
        },
        retry: false,
        notifyOnChangeProps: ['data', 'error']
      }
    );
  
    const updateProfileMutation = useMutation(updateAdminProfile, {
      onSuccess: (data) => {
        updateProfile(data);
        queryClient.setQueryData('adminProfile', data);
      },
      onError: (error) => {
        setError(error?.response?.data?.message || 'Failed to update profile');
      }
    });
  
    const updateProfileImageMutation = useMutation(updateProfileImage, {
      onSuccess: (data) => {
        updateProfile(data);
        queryClient.setQueryData('adminProfile', data);
      },
      onError: (error) => {
        setError(error?.response?.data?.message || 'Failed to update profile image');
      }
    });
  
    const updateBannerImageMutation = useMutation(updateBannerImage, {
      onSuccess: (data) => {
        updateProfile(data);
        queryClient.setQueryData('adminProfile', data);
      },
      onError: (error) => {
        setError(error?.response?.data?.message || 'Failed to update banner image');
      }
    });
  
    return {
      profile,
      updateProfile: updateProfileMutation.mutate,
      updateProfileImage: updateProfileImageMutation.mutate,
      updateBannerImage: updateBannerImageMutation.mutate,
      isLoading: 
        isFetchingProfile ||
        updateProfileMutation.isLoading ||
        updateProfileImageMutation.isLoading ||
        updateBannerImageMutation.isLoading,
      error:
        updateProfileMutation.error ||
        updateProfileImageMutation.error ||
        updateBannerImageMutation.error
    };
  };